import { render } from "./MedicineIndex.vue?vue&type=template&id=20152589&scoped=true"
import script from "./MedicineIndex.vue?vue&type=script&lang=js"
export * from "./MedicineIndex.vue?vue&type=script&lang=js"

import "./MedicineIndex.vue?vue&type=style&index=0&id=20152589&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20152589"]])

export default __exports__